<template>
  <v-card class="login-dialog__content" :class="layout == 'portal' ? 'fixit-background-gradient' : ''"
    :style="!$vuetify.breakpoint.smAndDown ? 'height: 600px' : ''">
    <v-app-bar flat color="rgba(0, 0, 0, 0)">
      <v-spacer></v-spacer>
    </v-app-bar>
    <div class="login-dialog--login__content-container">
      <div class="login-dialog--login__content-container--text">
        <h2 class="login-dialog--login__content-container--text__title">
          {{ title }}
        </h2>
        <span class="login-dialog--login__content-container--text__subtitle">{{
          description
        }}</span>
        <div class="login-dialog--login__content-container--text__input">
            <v-text-field
              ref="nameInput"
              type="text"
              :class="layout == 'portal' ? 'portal-theme' : ''"
              persistent-placeholder
              autocomplete="given-name"
              class="pt-6"
              v-model="firstName"
              label="Fornavn"
              :rules="[rules.required, rules.name]"
              validate-on-blur
              :background-color="
                layout == 'portal' ? '' : 'var(--v-primary-opacity-12)'
              "
            ></v-text-field>
            <v-text-field
              type="text"
              :class="layout == 'portal' ? 'portal-theme' : ''"
              persistent-placeholder
              autocomplete="family-name"
              v-model="lastName"
              label="Etternavn"
              :rules="[rules.required, rules.name]"
              validate-on-blur
              :background-color="
                layout == 'portal' ? '' : 'var(--v-primary-opacity-12)'
              "
            ></v-text-field>
        </div>
      </div>
      <div
          class="login-dialog--login__content-container--options"
          :class="
            !$vuetify.breakpoint.smAndDown
              ? 'login-dialog--login__content-container--options_limited'
              : ''
          "
        >
          <v-btn
            :disabled="firstName.trim().length < 2 || lastName.trim().length < 2"
            elevation="0"
            block
            color="var(--v-primary-base)"
            dark
            rounded
            :class="!$vuetify.breakpoint.smAndDown ? 'my-3' : ''"
            @click="$emit('submit', {firstName: firstName, lastName: lastName})"
          >
            Fortsett
          </v-btn>
        </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "the-about-step",
  props: {
    title: {
      required: true,
      default: "",
    },
    description: {
      required: true,
      default: "",
    },
    layout: {
      required: false,
      type: String,
      default: "chain",
    },
    tempUser: {
      required: false,
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      validated: false,
      rules: {
        required: (value) => !!value || "Dette feltet er obligatorisk.",
        name: (value) => {
          const pattern = /^[a-zA-Z\Wæøå]{2,}$/;
          return (
            pattern.test(value.trim()) ||
            "Navn kan ikke inneholde tall eller spesialtegn."
          );
        },
      },
    };
  },
  mounted() {
    this.firstName = this.tempUser.firstName;
    this.lastName = this.tempUser.lastName;
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.nameInput.$refs.input.focus();
      });
    });
  },
};
</script>

<style scoped>
.error--text {
  padding-bottom: 10px;
}
.portal-theme.theme--light.v-text-field:not(.v-input--has-state) {
  color: #579fa7 !important;
}
</style>
